<template>
  <v-card class="gallery">
    <template v-if="mediaDetail">
      <v-btn
        fab
        color="#fff"
        @click.native="closePhotoPage"
        class="dialog-close"
      >
        <v-icon color="#000">fas fa-xmark</v-icon>
      </v-btn>
      <v-row no-gutters>
        <v-col cols="12" :md="8" :lg="8">
          <div class="gallery-content">
            <v-img :src="mediaDetail.path" contain></v-img>
          </div>
        </v-col>
        <v-col cols="12" :md="4" :lg="4">
          <GalleryPanel :mediaDetail="mediaDetail" />
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <SlideMedia />
    </template>
  </v-card>
</template>
<script>
import SlideMedia from "@/components/Media/SlideMedia";
import GalleryPanel from "@/components/Courses/GalleryPanel";
export default {
  name: "Photo",
  components: {
    SlideMedia,
    GalleryPanel,
  },
  props: {
    mediaDetail: Object,
    isEmmit: Boolean,
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    closePhotoPage() {
      this.$emit("closeView");
    },
  },
  async created() {
    await this.$store.dispatch("getMe");
  },
};
</script>
<style lang="scss">
</style>